import { io } from "socket.io-client";
import { useEffect, useRef, useState } from "react";

const socket = io("http://192.168.100.52:3001"); // your backend URL

function Rocketie() {
    const myID = 100
    const sender = 'Jayson Smiths'
    const room = 12
    const health_bar = 50
    const victim = 88
    const Taker_id = 94
    const amount_taken = 100

    const sentRef = useRef(false);

     const [players, setPlayers] = useState([]);
    
  useEffect(() => {

    if (sentRef.current) return;
    sentRef.current = true;

    socket.emit("push_array", {
      myID: 100,
      sender: "Jayson Smiths",
      room: 12,
      health: 50,
      victim: 88,
      Taker_id: 94,
      amount_taken: 100
    });

  }, []);

    useEffect(() => {
    socket.on("array", (data) => {
      setPlayers(data);
    });

    return () => {
      socket.off("array");
    };
  }, []);


  const send = () => {
   //alert('good')
         socket.emit("bomb_message", {

            myID, // collection.myID
            sender, // colection.myname,
            room, //collection.room
            health: health_bar,
            victim,
            Taker_id,
            amount_taken
            
           });
  }

  return 
  <div>
    <button onClick={send}>Send Freeze</button>

     {players.map((player, index) => (
        <div key={index} style={{ border: "1px solid #ccc", margin: 10, padding: 10 }}>
          <p><strong>Name:</strong> {player.name}</p>
          <p><strong>ID:</strong> {player.ID}</p>
          <p><strong>Health:</strong> {player.health}</p>
          <p><strong>Room:</strong> {player.game_room}</p>
        </div>
      ))}
      
  </div>
}

export default Rocketie;